import { getOmni, postOmni, putOmni } from '../apiHelper/omniApi'
import {
  OmniauthTokenGenerate_URL,
  OmniauthTokenInvalidate_URL,
  OmniauthTokenRefresh_URL,
  OmniauthTokenSendMfa_URL,
  OmniauthTokenValidate_URL,
  OmniauthTokenVerifyMfa_URL,
  OmniauthUserPracticeProvider_URL,
} from '../apiHelper/apiRoute/omni'

export const refreshToken = (refreshToken) =>
  getOmni(OmniauthTokenRefresh_URL, { refresh_token: refreshToken })

export const validateToken = (accessToken) =>
  postOmni(OmniauthTokenValidate_URL, { access_token: accessToken })

export const invalidateToken = (accessToken) =>
  postOmni(OmniauthTokenInvalidate_URL, {
    access_token: accessToken || JSON.parse(localStorage.getItem('authUser') || null)?.authToken,
  })

export const setPracticeProvider = (data) => putOmni(OmniauthUserPracticeProvider_URL, data)

export const sendMfaPasscode = (mfaData) => postOmni(OmniauthTokenSendMfa_URL, mfaData)

export const verifyMfaPasscode = (mfaData) => postOmni(OmniauthTokenVerifyMfa_URL, mfaData)

export const loginOmniauth = (credentials) => postOmni(OmniauthTokenGenerate_URL, credentials)
